import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Referrals from "@/pages/Referrals";
import ReferralDetail from "@/pages/ReferralDetail";
import Report from "@/pages/Report";
import ImportWorkbook from "@/pages/Import";
import AuditLog from "@/pages/AuditLog";
import Users from "@/pages/Users";
import Contacts from "@/pages/Contacts";
import Analytics from "@/pages/Analytics";
import AccessReview from "@/pages/AccessReview";
import ActionPage from "@/pages/ActionPage";
import Settings from "@/pages/Settings";
import DeletedLog from "@/pages/DeletedLog";

function Protected({ children }) {
  const { user, checked } = useAuth();
  if (!checked) {
    return (
      <div className="app-bg flex items-center justify-center min-h-screen">
        <div className="font-mono text-cyan-400 text-sm tracking-widest animate-pulse">INITIALIZING…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function SuperOnly({ children }) {
  const { user } = useAuth();
  if (user && !user.is_super_admin) return <Navigate to="/" replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <Toaster theme="dark" position="top-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/action/:token" element={<ActionPage />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="referrals" element={<Referrals />} />
              <Route path="referrals/:id" element={<ReferralDetail />} />
              <Route path="report" element={<Report />} />
              <Route path="import" element={<ImportWorkbook />} />
              <Route path="audit" element={<AuditLog />} />
              <Route path="users" element={<SuperOnly><Users /></SuperOnly>} />
              <Route path="access-review" element={<SuperOnly><AccessReview /></SuperOnly>} />
              <Route path="deleted" element={<AdminOnly><DeletedLog /></AdminOnly>} />
              <Route path="settings" element={<Settings />} />
              <Route path="contacts" element={<Contacts />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
